import { createSlice } from "@reduxjs/toolkit";
import {
  getSettings,
  getSetting,
  updateSetting,
  createSetting,
} from "./thunk";

const initialState = {
  settings: [],
  singleSetting: null,
  loading: false,
  error: null,
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    clearSingleSetting: (state) => {
      state.singleSetting = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH ALL SETTINGS
      .addCase(getSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        console.log('Reducer received settings:', action.payload);
        state.loading = false;
        state.settings = action.payload || [];
        state.error = null;
      })
      .addCase(getSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch settings";
      })
      // FETCH SINGLE SETTING
      .addCase(getSetting.pending, (state) => {
        state.loading = true;
        state.singleSetting = null;
      })
      .addCase(getSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.singleSetting = action.payload;
        state.error = null;
      })
      .addCase(getSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch setting by ID";
      })
      // CREATE SETTING
      .addCase(createSetting.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.settings = [action.payload, ...state.settings];
        }
      })
      // UPDATE SETTING
      .addCase(updateSetting.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload;
        if (updated && Array.isArray(state.settings)) {
          const index = state.settings.findIndex((s) => s.id === updated.id);
          if (index !== -1) {
            state.settings[index] = updated;
          }
        }
      })
      // DELETE SETTING
      .addCase(require('./thunk').deleteSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = state.settings.filter(s => s.id !== action.payload);
      });
  },
});

export const { clearSingleSetting } = settingSlice.actions;
export default settingSlice.reducer;
